import { languageSchema } from "./languageSchema.js";

export const getNotificationTokenSchema = {
  querystring: {
    type: "object",
    properties: {
      token: { type: "string" },
    },
    required: ["token"],
  },
  response: {
    200: {
      type: "boolean",
    },
  },
};

export const notificationTokenSchema = {
  body: {
    type: "object",
    properties: {
      token: { type: "string" },
    },
    required: ["token"],
  },
};

export const notificationOpenSchema = {
  body: {
    type: "object",
    properties: {
      announcementId: { type: "integer" },
      eventId: { type: "integer" },
    },
    required: ["announcementId", "eventId"],
    additionalProperties: false,
  },
  response: {
    200: {
      type: "object",
      properties: {
        success: { type: "boolean" },
      },
    },
  },
};

const inboxEventQuery = {
  type: "object",
  properties: {
    eventId: { type: "integer" },
  },
  required: ["eventId"],
};

export const getInboxSchema = {
  querystring: {
    ...inboxEventQuery,
    properties: {
      ...inboxEventQuery.properties,
      page: { type: "integer", minimum: 1, default: 1 },
      limit: { type: "integer", minimum: 1, maximum: 100, default: 20 },
      ...languageSchema.properties,
    },
  },
};

export const getUnreadCountSchema = {
  querystring: inboxEventQuery,
};

export const markNotificationReadSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "integer" },
    },
    required: ["id"],
  },
};

export const recordPushOpenSchema = markNotificationReadSchema;

export const markAllNotificationsReadSchema = {
  querystring: inboxEventQuery,
};

export const getNotificationLogSchema = {
  querystring: {
    ...inboxEventQuery,
    properties: {
      ...inboxEventQuery.properties,
      producer: { type: "string", maxLength: 32 },
      dateFrom: { type: "string", format: "date" },
      dateTo: { type: "string", format: "date" },
      page: { type: "integer", minimum: 1, default: 1 },
      limit: { type: "integer", minimum: 1, maximum: 100, default: 20 },
    },
  },
};

export const getNotificationLogReadsSchema = {
  querystring: {
    ...inboxEventQuery,
    properties: {
      ...inboxEventQuery.properties,
      id: { type: "integer" },
    },
    required: ["eventId", "id"],
  },
};
